import './PageLayout.scss'

const PageLayout = ({children}: {children: React.ReactNode}) => {
    return <div className='page-layout'>{children}</div>
}

export default PageLayout;

